import React, { ReactElement } from 'react';
import { getStatusBarSizes } from 'utils/statusBar';

import { SafeAreaViewProps } from './SafeAreaView.types';
import styles from './SafeAreaView.module.scss';

function SafeAreaView({ children }: SafeAreaViewProps): ReactElement {
  const { topStatusBarSize, bottomStatusBarSize } = getStatusBarSizes();

  return (
    <div
      className={styles.wrapper}
      style={{
        marginTop: topStatusBarSize,
        marginBottom: bottomStatusBarSize,
      }}
      data-testid="SafeAreaView">
      {children}
    </div>
  );
}

export default SafeAreaView;
